import createLucideIcon from '../createLucideIcon';

const MoveRight = createLucideIcon('MoveRight', [
  ['path', { d: 'M18 8L22 12L18 16', key: '1r0oui' }],
  ['path', { d: 'M2 12H22', key: '1m8cig' }],
]);

export default MoveRight;
